const Icons = {
  methods: {
    applicationStatusIcon(id) {
      switch (id) {
        case 1:
          return '$sl-status-draft'
        case 2:
          return '$sl-approved-by-apprentice'
        case 3:
          return '$sl-approved-by-company'
        case 4:
          return '$sl-status-draft'
        case 5:
          return '$sl-approved-by-company'
        case 6:
          return '$sl-approved-by-apprentice'
        case 7:
          return '$sl-approved-by-company'
        case 9:
          return '$sl-approved-by-company'
        default:
          return '$sl-status-draft'
      }
    },
    orderStatusIcon(state) {
      switch (state) {
        case 'sentToCompanyForApproval':
          return '$sl-status-draft'
        case 'approvedByCompany':
          return '$sl-status-draft'
        case 'awaitingPayment':
          return '$sl-status-draft'
        case 'paid':
          return '$sl-status-paid'
        case 'commissioned':
          return '$sl-status-draft'
        case 'standby':
          return '$sl-status-draft'
        case 'created':
          return '$sl-status-draft'
        default:
          return '$sl-status-draft'
      }
    },
    applicationIconByName(name) {
      switch (name) {
        case 'draft':
          return '$sl-draft'
        case 'confirmedByCompany':
          return '$sl-confirmedByCompany'
        case 'confirmedByStudent':
          return '$sl-confirmedByStudent'
        case 'confirmedAndApprovedByCompany':
          return '$sl-confirmedAndApprovedByCompany'
        case 'approved':
          return '$sl-approved'
        case 'ordered':
          return '$sl-ordered'
        case 'closed':
          return '$sl-closed'
        default:
          return '$sl-draft'
      }
    }
  }
}

export default Icons
